$(document).ready(function () {
// Home page collection hover effect

$(".collection-part div .collection").hover(function() { // Mouse over
  $(this).parent().siblings().find('> div').addClass('artwork_not_hover');
  $(this).addClass('artwork_hover');
}, function() { // Mouse out
  $(this).parent().siblings().find('> div').removeClass('artwork_not_hover');
  $(this).removeClass('artwork_hover');
});

// ------------------  Instafeed  ----------------------
/*
var userFeed = new Instafeed({
        get: 'user',
        userId: 750073489,
        accessToken: '750073489.0a0c996.3b0e1cedc94d48b3bf57b76751e50c6b',
        resolution: 'standard_resolution',
        limit: 6,
        template: '<li style="background-image:url({{image}});"><a href="{{link}}"><img src="{{image}}" /></a></li>'
    });

  
  
  var userFeed2 = new Instafeed({
        get: 'user',
        userId: 750073489,
        accessToken: '750073489.0a0c996.3b0e1cedc94d48b3bf57b76751e50c6b',
        resolution: 'standard_resolution',
        limit: 5,
        target: 'instafeed--new', 
        template: '<div class="grid__cell unit-2-10 mobile__50"><a data-organism="card" href="{{link}}"><div data-molecule="card__image" style="background-image:url({{image}});"></div></a></div>'
    });
  
  if($('body').hasClass('test2')) {
  
  } else if($('body').hasClass('test1')) {
    userFeed2.run();
  } else {
    userFeed.run();
    
  }
    */
    
  if(window.location.hash) {
    
    var myBannerID = window.location.hash.replace('/', '').replace('#', '');
    
    if( $('#banner__'+myBannerID).length ) {
      $('.text-banner').addClass('hidden');
      $('#banner__'+myBannerID).removeClass('hidden');
    }
  
  } else {
    
  	if( $('#banner__default').length ) {
      $('.text-banner').addClass('hidden');
      $('#banner__default').removeClass('hidden');
    }
    
  }
  
  $('[data-modal="catalogue"]').on('click',function(event){
    event.preventDefault();
    $("#catalogueModal").modal('show');
  });
        
      
  
  

});// Document ready end


